import { Button, Icon, Text } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import colors from 'constants/colors'
import { RootState } from 'constants/interfaces'
import React from 'react'
import { BiExport } from 'react-icons/bi'
import { useSelector } from 'react-redux'

export default function ExportToExcellButton({
  handleExport,
  isLoading,
  isDisabled = false,
}: {
  handleExport: (includeSymbols?: boolean) => void
  isLoading: boolean
  isDisabled?: boolean
}) {
  const { locale } = useSelector((state: RootState) => state.general)

  const handleClick = () => {
    handleExport()
  }

  return (
    <Button
      ml={{
        base: locale === 'he' ? '3' : '0',
      }}
      mr={{
        base: locale === 'he' ? '0' : '3',
      }}
      px="3"
      py="3"
      borderRadius="10px"
      backgroundColor="#fff"
      border="1px solid rgba(170, 176, 188, 0.5)"
      onClick={handleClick}
      isLoading={isLoading}
      isDisabled={isDisabled}
      style={{ columnGap: '8px' }}
      _focus={{ outline: 'none' }}
    >
      <Text fontSize="14px" fontFamily='"Asap Condensed", sans-serif'>
        <LocaleText text="dashboard_export_excel_button" />
      </Text>
      <Icon as={BiExport} size="24px" color={colors.greyMain} />
    </Button>
  )
}
